var map = {
	"./en": [
		"edd4",
		3
	],
	"./en.json": [
		"edd4",
		3
	],
	"./hu": [
		"4e73",
		3,
		"chunk-2d0cc643"
	],
	"./hu.json": [
		"4e73",
		3,
		"chunk-2d0cc643"
	],
	"./i18n": [
		"8938",
		9
	],
	"./i18n.js": [
		"8938",
		9
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(2).map(__webpack_require__.e)).then(function() {
		return __webpack_require__.t(id, ids[1])
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "326a";
module.exports = webpackAsyncContext;